import * as React from 'react';
import AuthSubtitle from '../AuthSubtitle';
import AuthTitle from '../AuthTitle';

export interface IAuthContainerProps {
  children: React.ReactNode;
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
}

export default function AuthContainer(props: IAuthContainerProps) {
  const { children, title, subtitle } = props;
  return (
    <div className="container flex flex-col items-center justify-center mx-auto pt-8 pb-8  ">
      <div className="xs:w-full w-5/12 sm-max:w-full ">
        <AuthTitle title={title} />
        <AuthSubtitle subtitle={subtitle} />

        {children}
      </div>
    </div>
  );
}
